<main class="main-container">
    <div class="background-image"></div>
</main>